<script setup>
import { useGlobalStore } from '@stores/global'
import { useStoreStore } from '@stores/store'

import CartItem from '@components/cart/CartItem.vue'
import Button from '@components/global/button.vue'

const global = useGlobalStore()
const store = useStoreStore()

const checkout = () => {
	window.location.href = store.cart?.checkoutURL
}
</script>

<template>
	<div class="fixed right-0 top-0 isolate z-[1000] flex h-full w-full select-none justify-end">
		<div class="overlay fixed left-0 top-0 -z-10 hidden h-full w-full bg-black/75 md:block" @click="global.toggleCart(false)" />
		<div class="inner text-default relative z-10 flex h-full w-full flex-col gap-5 bg-bg-base p-6 pr-0 md:max-w-md 2xl:max-w-xl">
			<div class="flex items-center justify-between border-b border-border-muted py-2">
				<div class="flex w-full items-center justify-between text-2xl">
					<h5 class="label relative font-extrabold uppercase text-text-muted">Cart</h5>
					<Button class="btn icon" icon="fa-solid fa-xmark" @click="global.toggleCart(false)" />
				</div>
			</div>
			<div class="relative h-full flex-1 overflow-y-auto pr-6">
				<Transition name="fade">
					<div class="bg-bg absolute flex h-full w-full items-center justify-center gap-4" v-if="store.cartLoading">
						<i class="fa-solid fa-spinner-third animate-spin text-lg" />
						<p class="animate-pulse text-sm font-bold uppercase tracking-widest">Processing</p>
					</div>
				</Transition>
				<div class="my-10 flex grow items-center justify-center gap-4" v-if="!store.cart.products?.length">
					<p class="text-sm font-bold uppercase tracking-widest">Your cart is empty</p>
				</div>
				<div class="flex flex-1 grow flex-col gap-5 overflow-y-auto" v-else>
					<CartItem v-for="product in store.cart.products" :key="product.slug" :product="product" />
				</div>
			</div>
			<div class="border-border flex flex-col gap-1.5 rounded-small mr-6 bg-bg-light p-4 text-body-sm uppercase">
				<div class="flex items-center justify-between text-base text-text-muted/50">
					<p>taxes</p>
					<i class="fa-solid fa-spinner-third animate-spin" v-if="store.cartLoading"></i>
					<p v-else>tbd</p>
				</div>
				<div class="flex items-center justify-between text-base text-text-muted/50">
					<p>shipping</p>
					<i class="fa-solid fa-spinner-third animate-spin" v-if="store.cartLoading"></i>
					<p v-else>tbd</p>
				</div>

				<div class="flex items-center justify-between text-base font-bold">
					<p>Total</p>
					<i class="fa-solid fa-spinner-third animate-spin" v-if="store.cartLoading"></i>
					<p v-else>{{ store.cart.cost?.subtotal ?? '$0.00' }} + taxes & shipping</p>
				</div>

				<div class="my-2 w-full overflow-hidden">
					<svg xmlns="http://www.w3.org/2000/svg" width="864" height="2" viewBox="0 0 864 2" fill="none">
						<path d="M0 1H864" stroke="#756AAF" stroke-width="1.5" stroke-dasharray="2 6" />
					</svg>
				</div>

				<p class="text-body-sm font-bold">Continue to shopify for payment, taxes and shipping.</p>
			</div>
			<Button :disabled="store.cartLoading || !store.cart.products?.length" @click="checkout" class="btn-outline mr-6">
				{{ store.cartLoading ? 'Please Wait' : 'continue to payment' }}
			</Button>
		</div>
	</div>
</template>

<style scoped>
.label:before {
	@apply absolute -bottom-[10px] left-0 h-[3px] w-full bg-sf-purple-base content-[''];
}
</style>
